import { render, staticRenderFns } from "./systemTemplateTop.vue?vue&type=template&id=0126a544&scoped=true&"
import script from "./systemTemplateTop.vue?vue&type=script&lang=js&"
export * from "./systemTemplateTop.vue?vue&type=script&lang=js&"
import style0 from "./systemTemplateTop.vue?vue&type=style&index=0&id=0126a544&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0126a544",
  null
  
)

export default component.exports